import FW from '../fw/fw';
import Env from '../fw/env';
import Logger from '../fw/logger';
import CCManagement from './cc';


export default class VttJS {

  #rmp;
  #ccCues = [];
  #ccEnabled = false;
  #ccData = null;
  #updateCuesResizeFn = null;

  constructor(rmp, ccFiles) {
    this.#rmp = rmp;
    this.#rmp.ccFiles = ccFiles;
    this.#rmp.hasExternalCCFiles = true;
  }

  get ccData() {
    return this.#ccData;
  }

  set ccData(value) {
    this.#ccData = value;
  }

  get ccEnabled() {
    return this.#ccEnabled;
  }

  set ccEnabled(value) {
    this.#ccEnabled = value;
  }

  #ajaxCall(i) {
    return new Promise((resolve, reject) => {
      const ccFileUri = this.#rmp.ccFiles[i].uri;
      FW.ajax(ccFileUri, this.#rmp.ajaxWithCredentials, 'GET').
        then(data => {
          Logger.print('captions', `loaded WebVTT file at ${ccFileUri}`);
          if (typeof data === 'string') {
            let defaultCC = false;
            if (this.#rmp.ccFiles[i].default) {
              defaultCC = true;
            }
            this.#rmp.loadedCCFiles[i] = {
              lng: this.#rmp.ccFiles[i].lng,
              name: this.#rmp.ccFiles[i].name,
              uri: ccFileUri,
              default: defaultCC,
              data
            };
            this.#rmp.dispatch('texttrackloaded');
            resolve();
          }
        }).catch(error => {
          this.#rmp.loadedCCFiles[i] = {
            lng: '',
            name: '',
            uri: '',
            default: false,
            data: null
          };
          this.#rmp.dispatch('texttrackloaderror');
          this.#rmp.rmpUtils.warning(4002, error);
          reject();
        });
    });
  }

  #updateCues() {
    let currentTime = this.#rmp.currentTime;
    if (currentTime > -1) {
      currentTime = currentTime / 1000;
      const activeCues = [];
      this.#ccCues.forEach(ccCue => {
        const startTime = ccCue.startTime;
        const endTime = ccCue.endTime;
        if (currentTime >= startTime && currentTime <= endTime) {
          activeCues.push(ccCue);
        }
      });
      const ccArea = this.#rmp.dom.ccArea;
      if (activeCues[0] && this.#ccEnabled) {
        FW.show(ccArea);
        const playerSize = this.#rmp.getPlayerSize();
        if (playerSize.width > 0 && playerSize.height > 0) {
          ccArea.style.width = playerSize.width + 'px';
          ccArea.style.height = playerSize.height + 'px';
        }
        window.WebVTT.processCues(window, activeCues, ccArea, true);
      } else {
        FW.hide(ccArea);
      }
    }
  }

  #loadVTTFiles() {
    Logger.print('captions', 'ready - start loading VTT files');
    this.#updateCuesResizeFn = this.#updateCues.bind(this);
    this.#rmp.on('timeupdate resize', this.#updateCuesResizeFn);
    const arrayCCPromise = [];
    for (let i = 0, len = this.#rmp.ccFiles.length; i < len; i++) {
      arrayCCPromise[i] = this.#ajaxCall(i);
    }
    this.#rmp.rmpCCManagement = new CCManagement(this.#rmp);
    Promise.allSettled(arrayCCPromise).then((values) => {
      const found = values.find(value => value.status === 'rejected');
      if (found) {
        this.#rmp.rmpUtils.warning(4003);
      } else {
        Logger.print('captions', 'all external VTT files loaded');
      }
      this.#rmp.rmpCCManagement.appendUI();
    });
  }

  parse(caption) {
    if (typeof caption === 'string') {
      try {
        this.#ccCues = [];
        const parser = new window.WebVTT.Parser(window, window.WebVTT.StringDecoder());
        parser.oncue = (cue) => {
          this.#ccCues.push(cue);
        };
        parser.onparsingerror = (error) => {
          this.#rmp.rmpUtils.warning(4001, error);
        };
        parser.parse(caption);
        parser.flush();
        Logger.print('captions', 'vtt.js finished parsing captions', this.#ccCues);
      } catch (warning) {
        console.warn(warning);
      }
      this.#ccEnabled = true;
      FW.show(this.#rmp.dom.ccArea);
      this.#ccData = this.#ccCues;
    }
  }

  destroy() {
    this.#rmp.off('timeupdate resize', this.#updateCuesResizeFn);
    this.#ccCues = [];
  }

  init() {
    if (Env.isIos[0]) {
      // runs in InitManagement createVideoTag
      return;
    } else {
      if (typeof window.WebVTT !== 'undefined') {
        this.#loadVTTFiles();
      } else {
        // do not change to const pathToRmpFiles = this.#rmp.pathToRmpFiles or grunt replace won't work
        let callScript = this.#rmp.pathToRmpFiles + 'vtt/vtt.min.js';
        if (DEBUG) {
          callScript = this.#rmp.pathToRmpFiles + 'vtt/vtt.js';
        }
        Logger.print('captions', 'starts loading vtt.js lib at ' + (FW.getNow() - this.#rmp.refTime) + ' ms');
        FW.getScript(
          callScript,
          this.#loadVTTFiles.bind(this),
          this.#rmp.rmpUtils.warning.bind(this.#rmp.rmpUtils, 4000),
          this.#rmp.shadowRoot
        );
      }
    }
  }

}
